import { connect } from 'react-redux'

import { resetRecipe } from '~p/client/common/actions'
import controlTree from '~c/client/controlTree'
import ResetRecipe from '../components/ResetRecipe'

export default connect(null, (dispatch) => ({
  resetRecipe: () => dispatch(resetRecipe(controlTree)),
}))(ResetRecipe)
